import { render } from "./DrivenFooter.vue?vue&type=template&id=67ad5cfb&scoped=true"
import script from "./DrivenFooter.vue?vue&type=script&lang=js"
export * from "./DrivenFooter.vue?vue&type=script&lang=js"

import "./DrivenFooter.vue?vue&type=style&index=0&id=67ad5cfb&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ad5cfb"]])

export default __exports__